<template>
    <div :class="classes" v-loading="loading">
       <el-menu :default-active="curActive" class="el-menu-vertical-demo" @open="handleOpen" :collapse="collapse" ref="elMenuTree" :default-openeds="defaultOpeneds"
            :router="true" @select="handleSelect" :background-color="backgroundColor" :unique-opened="true" :text-color="textColor" :active-text-color="activeTextColor">
            <template v-if="config&&config.length">
            <template v-for="(item,index) in config">
                <wt-menu-tree-item :data="item" :index="String(index + 1)" :key="item.action?item.action:index" @mount-menu-item="updateMenuItem"
                ref="menuItem" :selectNumber="selectNumber" @getStore="getStore" v-if="item.enable"></wt-menu-tree-item>
            </template>
            </template>
            <slot/>
            <wt-box class="add-menu" @click.native="add_menu" v-if="isAdd">
              <i class="el-icon-plus"></i>
            </wt-box>
            <!-- <div class="add-menu" @click.native="add_store" v-if="!isNoAdd">
              <img :src="require('images/Add-mune.png')" />
            </div> -->
         </el-menu>
    </div>
</template>

<script>
// 组件class前缀
import { Menu } from 'element-ui'
import wtMenuTreeItem from '../menu-tree-item/wt-menu-tree-item'
const prefixCls = 'wt-menu-tree'
export default {
  name: 'wt-menu-tree',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    elMenuTree(){
      return this.$refs.elMenuTree
    }
  },
  props: {
    config: {
      type: [Array, String, Boolean],
      // required: true
    },
    defaultActive: {
      // 默认路由
      type: [Number, String],
      default: '/'
    },
    collapse: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    activeTextColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      menuItems: [],
      index: 0,
      curActive: this.defaultActive,
      selectNumber: 0,
      is_action:false,
      defaultOpeneds:[],
      loading:false
    }
  },
  components: {
    wtMenuTreeItem,
    'el-menu': Menu
  },
  watch: {
    config: {
      handler: function (val) {
        let actionUrl
        if (val) {
          val.forEach(item =>{
          if (this.$router.history.current.params.store_id &&item.action.indexOf(this.$router.history.current.params.store_id) > -1) {
              // actionUrl = item.action
            }
          })
          if (actionUrl) {
            this.curActive = actionUrl
          } else {
            this.$nextTick(_=>{
            this.curActive = this.setSelectMenu(val)

            })
            //此处为强行收起除激活菜单以外的其他菜单，因为element的菜单在默认打开选中菜单时会打开相邻菜单，在只能有一个菜单打开的情况下做的折中方案
            // this.$nextTick(_=>{
            //   let openedMenus=this.elMenuTree.openedMenus
            //   openedMenus.forEach(item=>{
            //     this.defaultOpeneds.forEach(etem=>{
            //       if(item!==etem){
            //         this.elMenuTree.closeMenu(item)
            //       }
            //     })
            //   })
            // })
            //此处为强行收起除激活菜单以外的其他菜单，因为element的菜单在默认打开选中菜单时会打开相邻菜单，在只能有一个菜单打开的情况下做的折中方案
          }
        }
      },
      immediate: true
      // this.is_action = val[0] && (val[0].children ? val[0].children[0].action : val[0].action);
    },
    $route :{
      handler:function (val){
        this.curActive = this.setSelectMenu(this.config)
      },
      deep:true
      }
  },
  methods: {
    //从当前菜单中获取当前路由的菜单项，以选中,递归得出选中的菜单并打开其父菜单
    setSelectMenu(data,key){
       for (let v=0;v<data.length;v++) {
        let item = data[v]
        let keyUse=key?(key+'-'+(v+1)):(v+1)
        // 1.判断是对象或者数组
        if (item.children&&item.children.length) {
          if(this.setSelectMenu(item.children,keyUse)) return this.setSelectMenu(item.children,keyUse)
        } else {
            if (item.action === this.$route.path ||this.$route.path.indexOf(item.action) > -1||item.action.indexOf(this.$route.path)>-1) {
              let keySplice=typeof(keyUse)==='number'?keyUse:keyUse.split('-')
              this.defaultOpeneds=[]
              for(let i=0;i<(keySplice.length-1);i++){
              this.defaultOpeneds.push(keySplice[i])
              }
              return item.action
              }
        }
      }
      
    },
    //根据当前连接锁定当前的菜单选中
    getRouterOfmenu(){
      for(let i=0;i<this.config.length;i++){
        let item = this.config[i]
        // if(item.children&&)

      }
      this.config.forEach(item=>{

      })
    },
    add_menu () {
      this.$emit('add-menu')
    },
    handleSelect (key, keypath) {
      let openedMenus=this.elMenuTree.openedMenus
      if(keypath.length<=2){
        if(keypath[0]!==openedMenus[0]){
          this.elMenuTree.closeMenu(openedMenus[0])
        }
      }
      if(keypath.length>2){
        if(keypath[keypath.length-3]!==openedMenus[openedMenus.length-1]){
          this.elMenuTree.closeMenu(openedMenus[openedMenus.length-1])
        }
      }
			this.selectNumber = keypath[2]
			this.$emit('handleSelect',key,keypath)
    },
    handleOpen (key, indexPath) {
      // this.action_index = key
    },
    getStore (item) {
      this.$emit('getStore', item)
      this.$router.push(item.action,()=>{},()=>{})
    },
    updateMenuItem (menuItem) {
      this.menuItems.push(menuItem)
    },
    setMenuItemActive () {
      let curPath = this.$router .history.current.fullPath.slice(1) // 去掉路劲开头的‘/’符号
      let needToActiveMenuItem = this.menuItems.filter(menuItem => {
        // 取消所有菜单激活状态
        if (!menuItem) {
          return
        }
        menuItem.$el.classList.remove('is-active')
        let menuItemPath = menuItem.index.slice(1)
        return (
          !!curPath &&
                  !!menuItemPath &&
                  curPath.indexOf(menuItemPath) === 0
        )
      })[0]
      needToActiveMenuItem &&
              needToActiveMenuItem.$el.classList.add('is-active')

      // 不要尝试用以下方式来激活菜单，会存在一些问题
      // this.curActive = this.$router.history.current.fullPath
    }
  },
  created () {
    // 这里采用的原生location对象获取路由，因为此时vue-Router信息还没初始化成功，通过它获取不到
    let path = window.location.href.replace(
      window.location.origin + '/#',
      ''
    )
    if (this.defaultActive !== path) {
      this.curActive = path
    }
    window.addEventListener('hashchange', this.setMenuItemActive)
  },
  beforeDestroy () {
    window.removeEventListener('hashchange', this.setMenuItemActive)
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
//----------------随便定义的
@fontColor:#333;
.markdown-body ul{
  padding-left: 0;
}
.el-menu-vertical-demo {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
.wt-menu-tree {
  text-align: left;
  .el-menu {
      border-right: none;
      background-color: transparent !important;
      .menu-tree-item {
          color: #000;
      }
      .add-menu {
          height: 56px;
          border-bottom: 1px solid #d8e1e8;
          .el-icon-plus{
              color: #4B557A;
              font-size: 30px;
          }
          img {
              height: 0.28rem;
              width: auto;
          }
      }
      .el-submenu__title,
      .el-menu-item {
          min-width: 1.8rem;
          // padding: 0 20px !important;
          color: @fontColor;
          &:hover {
              color: @fontColor;
          }
          &.is-active {
              color: @fontColor;
              i {
                  color: @fontColor;
              }
          }
      }
  }
  .el-menu.el-menu--collapse{
    .el-submenu__title{
      i.el-submenu__icon-arrow {
          display: none;
      }
    }
  }
}
</style>
